import React from 'react';
import styled from 'styled-components';
import {FormattedMessage} from 'react-intl';
import {FieldArray, formValueSelector} from 'redux-form';
import {
    FORM_CAR_REQUEST_SECTION,
    FORM_FIELD_ATTACHMENTS,
    FORM_FIELD_NEW_ATTACHMENTS,
    FORM_TICKET_SECTION
} from '../../../../../../constants/formConstants';
import {validTicketFiles} from '../../../../../common/validationCommons';
import {connect} from 'react-redux';
import {downloadAttachment} from '../../../../../../actions/orders/actionAttachments';
import moment from 'moment';
import RenderDropZone from '../../../../../common/RenderDropZone';
import UploadedAttachments from '../attachments/UploadedAttachments';
import formMessages from "../../../../../../intl/sparePartsOrders/formMessages";
import {moduleRoles} from '../../../../../../utils/roles';

const StyledDiv = styled.div`
  border-radius: 5px;
`;

const compare = (a, b) => {
    return moment(a.created).isAfter(b.created) ? 1 : -1;
};

const CarCourtesyAttachment = ({attachments = {}, userRights, readOnly, form, roles}) => {

    const canReadAttachment = (attachment) => {
        if (moduleRoles.isEditorOrder(roles) || moduleRoles.isSGEditorOrder(roles) || !attachment.solutionGroup) {
            return true;
        }
        return attachment.solutionGroup.canForwardToDealer;
    }

    const dealerAttachments = Object.keys(attachments)
        .map(item => attachments[item])
        .filter(item => item.isDealer)
        .sort(compare);

    const editorAttachments = Object.keys(attachments)
        .map(item => attachments[item])
        .filter(item => item.isEditor)
        .filter(item => canReadAttachment(item))
        .sort(compare);

    return (
        <>
            {((userRights.canAddAttach && !readOnly) || (attachments && Object.keys(attachments).length > 0)) &&
            <>
                <label className="col-form-label pl-0 font-weight-bold">
                    <FormattedMessage {...formMessages.JOIN_DOCUMENT}/>
                </label>
                <StyledDiv className="border border-secondary bg-white overflow-hidden">
                    {(dealerAttachments && dealerAttachments.length > 0) && <UploadedAttachments
                        attachments={dealerAttachments} label={formMessages.JOINED_DOCUMENTS} form={form}/>
                    }
                    {(editorAttachments && editorAttachments.length > 0) && <UploadedAttachments
                        attachments={editorAttachments} label={formMessages.JOINED_DOCUMENTS} form={form}/>
                    }
                    {userRights.canAddAttach && !readOnly && <FieldArray
                        name={FORM_FIELD_NEW_ATTACHMENTS}
                        component={RenderDropZone}
                        validate={validTicketFiles}/>
                    }
                </StyledDiv>
            </>
            }
        </>
    )
};

const mapStateToProps = (state, initialProps) => ({
    attachments: formValueSelector(initialProps.form)(state, `${FORM_CAR_REQUEST_SECTION}.${FORM_FIELD_ATTACHMENTS}`),
    ticketId: formValueSelector(initialProps.form)(state, `${FORM_TICKET_SECTION}.uuid`),
    roles: state.profile.userDetail.roles,
});

export default connect(mapStateToProps, {
    downloadAttachment,
})(CarCourtesyAttachment);
